<template>
  <section class="bg-light page-section" id="portfolio">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 text-center">
          <h2 class="section-heading text-uppercase" style="color:#ea1e29">Our Products</h2>
          <h3 class="section-subheading text-muted">
            Have a look through our products
          </h3>
        </div>
      </div>
       <v-container fluid><v-row align="centre" justify="centre" >
         <v-hover v-slot:default="{ hover }">
     <v-card
     raised
     rounded
    class="mx-auto portfolio-item"
    color="#231f20"
    dark
    max-width="400"
  >
    <v-card-title>
      <v-list-item-icon>
                <i class="fas fa-plane-departure fa-7x" style="color:#ea1e29;"></i>
              </v-list-item-icon>
    </v-card-title>
      <v-card-text class="headline font-weight-bold">Export </v-card-text>
<v-card-text class="headline font-weight-light">MAY Exports trades the Vietnamese delicacies and delights with the rest of the world. Some of which are UAE, Oman, Saudi Arabia, Qatar, Bahrain, Kuwait, Malyasia.   </v-card-text>
  

    <v-card-actions>
      <v-list-item class="grow">
        

       <v-divider></v-divider> <i class="fas fa-arrow-right fa-2x"></i> <v-divider></v-divider>
      </v-list-item>
    </v-card-actions><v-expand-transition>
          <div
            v-if="hover"
            class="d-flex transition-fast-in-fast-out  v-card--reveal display-3 white--text"
            style="height: 100%; background-color:#ea1e29;"
          >
            <v-btn
                  class=" font-weight-bold"
                  outlined
                  raised
                  light
                  color="#231f20"
                  v-on="on"
                  
                        @click="eproductdialog=true"

                  :id="key"
                  >View Products</v-btn
                >
          </div>
        </v-expand-transition>
        <v-dialog v-model="eproductdialog" fullscreen hide-overlay transition="dialog-bottom-transition"><v-card >
          <v-app-bar
        class="navbar-expand-lg"
        color="rgba(255, 255, 255, 0.9)"
        app
        height="100px"
      ><v-btn @click="eproductdialog=false" text><i class="fas fa-arrow-left fa-3x"></i></v-btn></v-app-bar>
          <div class="row">
        <div class="col-lg-12 text-center">
          <h2 class="section-heading text-uppercase" style="color:white">Export Products</h2>
          <h3 class="section-subheading " style="color:white">
            Have a look through our products
          </h3>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 text-center">
          <h2 class="section-heading text-uppercase" style="color:#ea1e29">Export Products</h2>
          <h3 class="section-subheading text-muted">
            Have a look through our products
          </h3>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="row" >

            
<div class="col-md-4 col-sm-6" v-for="(obj, key) in portfolioJSON"
          :key="key">
<v-card
    class="mx-auto"
    max-width="344"
    >
    <v-img class="img-fluid"
      :src="obj.img"
      
    ></v-img>

    <v-card-title  >
     {{ obj.caption }}
    </v-card-title>

    <v-card-text>{{ obj.title }}</v-card-text>

    <v-card-actions>
      <v-dialog v-model="dialog" max-width="1000" :retain-focus="false">
              <template v-slot:activator="{ on }">
                <v-btn
                  class="ma-2"
                  outlined
                  color="#231f20"
                  light
                  v-on="on"
                  @mousedown="handleClick"
                        @click="overlay = !overlay"

                  :id="key"
                  >see more</v-btn
                >
              </template>
              <div class="text-center">
    

    
  </div>
              <v-card class="startlower">
                <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
                <div class="container testing">
                  
                  <div class="container">
                    <div class="row text-center">
                      <div class="col-lg-12 text-center">
                        <h2 class="section-heading text-uppercase">
                          {{ dialogInf.caption }}
                        </h2>
                        <h5 class="text-muted">
                          {{ dialogInf.title }}
                        </h5>
                      </div>
                      <v-expansion-panels hover>
                        <v-expansion-panel disabled
                          v-for="(item, i) in innerProducts"
                          :key="i"
                        >
                          <v-expansion-panel-header>
                            <span>
                             
                            </span>
                            <span> {{ item.caption }}</span>
                          </v-expansion-panel-header>
                          
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </div>
                  </div>
                </div>
                <v-card-actions class="back-button">
                  <v-spacer></v-spacer>
                  <v-btn style="color:#392F51" @click="dialog = false"
                    >Back</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
    </v-card-actions>
</v-card>




</div>












        
      </div>
        </div>

      </div>
    </v-card></v-dialog>
  </v-card></v-hover>
  <v-hover v-slot:default="{ hover }">
     <v-card
     raised
     rounded
    class="mx-auto portfolio-item"
    color="#ea1e29"
    dark
    max-width="400"
  >
    <v-card-title>
      <v-list-item-icon>
                <i class="fas fa-plane-arrival fa-7x" style="color:#231f20;"></i>
              </v-list-item-icon>
    </v-card-title>
      <v-card-text class="headline font-weight-bold">Import </v-card-text>
<v-card-text class="headline font-weight-light">Although we are an export company, some goods are too good to not bring in! Have a look through some of the products that are brought in from our own factories in India. </v-card-text>
  

    <v-card-actions>
      <v-list-item class="grow">
        

       <v-divider ></v-divider> <i class="fas fa-arrow-right fa-2x"></i> <v-divider></v-divider>
      </v-list-item>
    </v-card-actions><v-expand-transition>
          <div
            v-if="hover"
            class="d-flex transition-fast-in-fast-out  v-card--reveal display-3 white--text"
            style="height: 100%; background-color:#231f20;"
          >
            <v-btn
                  class=" font-weight-bold"
                  outlined
                  raised
                  light
                  color="#ea1e29"
                  v-on="on"
                  @click="iproductdialog=true"

                  :id="key"
                  >View Products</v-btn
                >
          </div>
        </v-expand-transition>
        <v-dialog v-model="iproductdialog" fullscreen hide-overlay transition="dialog-bottom-transition"><v-card >
          <v-app-bar
        class="navbar-expand-lg"
        color="rgba(255, 255, 255, 0.9)"
        app
        height="100px"
      ><v-btn @click="iproductdialog=false" text><i class="fas fa-arrow-left fa-3x"></i></v-btn></v-app-bar>
          <div class="row">
        <div class="col-lg-12 text-center">
          <h2 class="section-heading text-uppercase" style="color:white">Import Products</h2>
          <h3 class="section-subheading " style="color:white">
            Have a look through our products
          </h3>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 text-center">
          <h2 class="section-heading text-uppercase" style="color:#ea1e29">Import Products</h2>
          <h3 class="section-subheading text-muted">
            Have a look through our products
          </h3>
        </div>
      </div><div class="container">
        <div class="row">
          <div class="row" >
      
    <v-card raised class="mx-auto " max-width="770px" style="padding:10px;">
      <v-row>
            <div class="container">
        <div class="row">
          <div class="row" >
              <v-card flat tile class="mx-auto " v-for="image in amroonImgs" :key="image"  style="padding-top:10px;">
                <v-img
                  :src="image"
                 
                  
                  max-height="1800px" max-width="300px"
                  class="grey lighten-2"
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-card>
          </div></div></div>
          </v-row>
    <v-card
    class="mx-auto"
    max-width="300"
    tile
  >
    <v-list dense>
      <v-subheader><h3 class="section-subheading text-muted">Buffalo Meat</h3> </v-subheader>
      <v-list-item-group v-model="item" color="primary">
        <v-list-item
          v-for="(item, i) in typecuts"
          :key="i"
        >
          <v-list-item-icon>
            <v-avatar size="36px">
                                <img
                                  v-if="item.icon"
                                  alt="Avatar"
                                  :src="item.icon"
                                />
                              </v-avatar>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="text-muted" v-text="item.text"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-card>
      <v-card-text>MAY Exports Vietnam Co. Limited imports some of the finest cuts of buffalo meat into Vietnam.
Our three factories based in India are registered in Vietnam and are responsible for the processing of our
buffalo meat: Fair Exports Pvt Limited (APEDA 68) Fair Exports Pvt Limited (APEDA 183) and Amroon Foods Pvt Limited(APEDA 42). After the meat has been
carefully processed in ways which meet the necessary sanitation codes, the meat is exported to
Vietnam where MAY Exports supply customers with our exceptional range of buffalo meats. The
main brands which we import into Vietnam are Al Tamam and Amroon. </v-card-text><v-card-text>For more information please <a class="lululink" style="text-decoration: none; color: #ea1e29;" href="https://fairexports.net/" target="_blank">click here</a> </v-card-text>
      <v-row>
            <div class="container">
        <div class="row">
          <div class="row" >
              <v-card flat tile class="mx-auto " v-for="image in altamamImgs" :key="image"  style="padding-top:10px;" >
                <v-img
                  :src="image"
                 
                  
                  max-height="1800px" max-width="300px"
                  class="grey lighten-2"
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-card>
          </div></div></div>
          </v-row></v-card>
          </div></div></div>
      </v-card></v-dialog>
  </v-card></v-hover>
  
  </v-row></v-container>
  
      <!-- <div class="row text-center" >
        <div
          class="col-md-4 col-sm-6 portfolio-item"
          v-for="(obj, key) in portfolioJSON"
          :key="key"
        >
          <a class="portfolio-link" data-toggle="modal" href="#portfolioModal2">
            <img class="img-fluid" :src="obj.img" />
          </a>
          <div class="portfolio-caption" >
            <h4>{{ obj.caption }}</h4>
            <p class="">{{ obj.title }}</p>
            <br />
            <v-dialog v-model="dialog" max-width="1000" :retain-focus="false">
              <template v-slot:activator="{ on }">
                <v-btn
                  class="ma-2"
                  outlined
                  color="#231f20"
                  light
                  v-on="on"
                  @mousedown="handleClick"
                        @click="overlay = !overlay"

                  :id="key"
                  >see more</v-btn
                >
              </template>
              <div class="text-center">
    

    
  </div>
              <v-card class="startlower">
                <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
                <div class="container testing">
                  <div class="row text-center" v-if="displayfmcg === true">
                    <div class="col-lg-12 text-center">
                      <h2 class="section-heading text-uppercase">FMCG</h2>
                      <h5 class="text-muted">
                        Lorem ipsum dolor sit amet, consectetur adipisicing
                        elit. Minima maxime quam architecto quo inventore harum
                        ex magni, dicta impedit.
                      </h5>
                    </div>
                    <div
                      class="col-md-3 col-sm-6"
                      v-for="(obj, key) in fmcgclientJSON"
                      :key="key"
                    >
                      <a>
                        <img
                          class="img-fluid d-block mx-auto"
                          :src="obj.clientImg"
                          :alt="obj.clientName"
                        />
                      </a>
                    </div>
                  </div>
                  <div class="container" v-else>
                    <div class="row text-center">
                      <div class="col-lg-12 text-center">
                        <h2 class="section-heading text-uppercase">
                          {{ dialogInf.caption }}
                        </h2>
                        <h5 class="text-muted">
                          {{ dialogInf.title }}
                        </h5>
                      </div>
                      <v-expansion-panels hover>
                        <v-expansion-panel
                          v-for="(item, i) in innerProducts"
                          :key="i"
                        >
                          <v-expansion-panel-header>
                            <span>
                              <v-avatar size="36px">
                                <img
                                  v-if="item.avatar"
                                  alt="Avatar"
                                  :src="item.avatar"
                                />
                              </v-avatar>
                            </span>
                            <span> {{ item.caption }}</span>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <v-list elevation="10px" rounded>
                              <v-list-item
                                v-for="(innerproductitem, j) in item.innerItems"
                                :key="j"
                              >
                                <v-list-item-icon
                                  ><i class="far fa-circle"></i
                                ></v-list-item-icon>
                                <v-list-item-content
                                  v-text="innerproductitem.title"
                                ></v-list-item-content>
                              </v-list-item>
                            </v-list>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </div>
                  </div>
                </div>
                <v-card-actions class="back-button">
                  <v-spacer></v-spacer>
                  <v-btn style="color:#392F51" @click="dialog = false"
                    >Back</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </div>
      </div> -->
    </div>
  </section>
</template>
<script>
export default {
  data: () => ({
    on:"",
    key:"",
    item:"",
    eproductdialog:false,
    iproductdialog:false,
    overlay: false,
    portfolioJSON: [
      
      {
        id: "0",
        img: require("../assets/img/fandv.jpg"),
        caption: "Fruits & Vegetables",
        title:
          "MAY Exports is responsible for sourcing and supplying some of the ripest and finest quality fruits and vegetables in the importing and export scene. Our fruit and vegetable products range from everyday consumption items such as sweet potatoes to more unfamiliar but still delectable items such as the pomelo. Please see our seasonal calendars for more information.",

        products: [
          {
            id: "0",
            caption: "Seedless Lime",
            
          },
          {
            id: "1",
            caption: "Guava",
            
          },
          {
            id: "2",
            caption: "Dragon fruit",
            
          },
          {
            id: "3",
            caption: "Sweet potatoe",
            
          },
          {
            id: "4",
            caption: "Watermelon Red seedless",
            
          },
          {
            id: "5",
            caption: "Watermelon Yellow seedless",
            
          },
          {
            id: "6",
            caption: "Tender Coconut",
            
          },
          {
            id: "7",
            caption: "Pomelo",
            
          },
          {
            id: "8",
            caption: "Longan",
            
          },
          {
            id: "8",
            caption: "Ginger",
            
          },
          {
            id: "9",
            caption: "Carrot",
            
          }
        ]
      },
      {
        id: "1",
        img: require("../assets/img/medical.jpg"),
        caption: "Medical Products",

        title:
          "When the COVID-19 pandemic gripped the world, MAY Exports found a way to provide relief to the global panic and shortage of the necessary medical supplies required for personal and larger corporate safety. Our medical products mainly consist of Personal Protective Equipment (PPE) items.",

        products: [
          {
            id: "0",
            caption: "Latex Gloves"
          },
          {
            id: "1",
            caption: "Nitrille Gloves"
          },
          {
            id: "2",
            caption: "Face Shield",
            
          },
          {
            id: "3",
            caption: "4 Layer Face Mask",
            
          },
          {
            id: "4",
            caption: "Surgical Gown",
            
          },
          {
            id: "4",
            caption: "Coverall",
            
          }
        ]
      },
      
      {
        id: "2",
        img: require("../assets/img/household.jpg"),
        caption: "Household",

        title:
          "Our household items illustrate a range in cook ware and storage items of either plastic, or for our more environmentally friendly customers, bamboo and rattan household items.",

        products: [
          {
            id: "0",
            caption: "Plastic household items"
          },
          {
            id: "1",
            caption: "Steel cookware"
          },
          {
            id: "2",
            caption: "Bamboo Products",
            
          },
          {
            id: "3",
            caption: "Rattan Products",
            
          }
        ]
      },
      {
        id: "3",
        img: require("../assets/img/comm.jpg"),
        caption: "Commodities",

        title:
          "MAY Exports boasts an array of sublime commodity items to satisfy almost any palate. We also export gạo thơm, a Vietnamese local Jasmine rice which was popularised in Ho Chi Minh City (formally Saigon) in the early 20 th Century.",

        products: [
          {
            id: "0",
            caption: "Jasmine Rice"
          },
          {
            id: "1",
            caption: "White rice 5% Broken"
          },
          {
            id: "2",
            caption: "Black pepper",
            
          },
          {
            id: "3",
            caption: "Cinnamon",
            
          },
          {
            id: "4",
            caption: "Cashew Nut",
            
          }
        ]
      },
      {
        id: "4",
        img: require("../assets/img/frozen.jpg"),
        caption: "Frozen",

        title:
          "MAY Exports has an impressive assemblage of different fish and shellfish caught fresh, and later frozen to assure quality. We recommend pairing our fish with some of our flavour enhancing fruits and vegetables, such as ginger or coconut.",

        products: [
          {
            id: "0",
            caption: "White fish fillet (Pangasius)"
          },
          {
            id: "1",
            caption: "Shrimp"
          },
          {
            id: "2",
            caption: "Tilapia",
            
          },
          {
            id: "3",
            caption: "Black Pomfret",
            
          }
        ]
      },
      {
        id: "5",
        img: require("../assets/img/garments.jpg"),
        caption: "Garments",

        title:
          "Our retail division is one of our top exports for MAY Exports and for good reason. While most of the garments are manufactured, many are also handmade, exemplifying MAY Export’s commitment to community building.",

        products: [
          {
            id: "0",
            caption: "Ladies Garments"
          },
          
          {
            id: "1",
            caption: "Sportswear",
            
          },
          {
            id: "2",
            caption: "Mens Garments",
            
          },
          {
            id: "3",
            caption: "Children Garments",
            
          }
        ]
      },
       
    ],
    
    dialog: false,
    displayfmcg: false,
    dialogInf: {
      
    },
    innerProducts: [
      
    ],
    altamamImgs:[require("../assets/img/altamam.jpg"),require("../assets/img/altamamtwo.jpg")],

    amroonImgs:[require("../assets/img/amroon.jpg"),require("../assets/img/amroontwo.jpg")],
    typecuts:[{text:"Hindquarter(Hq) Cuts",icon:require("../assets/img/hq.png")},{text:"Compensated cuts",icon:require("../assets/img/commed.jpg")},{text:"Offal cuts",icon:require("../assets/img/offal.jpg")}]
  }),
  watch: {
      overlay (val) {
        val && setTimeout(() => {
          this.overlay = false
        }, 1000)
      },
    },
  methods: {
    handleClick(ide) {
      this.displayfmcg = false;
      console.log(ide.toElement.id,ide.srcElement.parentNode.id)
      if (ide.toElement.id === "" && ide.srcElement.parentNode.id === "") {
        alert("error");
      } else {
        if (ide.toElement.id === "") {
          for (let i = 0; i < this.portfolioJSON.length; i++) {
            if (ide.srcElement.parentNode.id === this.portfolioJSON[i].id) {
              
                this.dialogInf = this.portfolioJSON[i];
                this.innerProducts = this.portfolioJSON[i].products;
              

              console.log("hehehheh");
            }
          }
        } else if (ide.srcElement.parentNode.id === "") {
          for (let i = 0; i < this.portfolioJSON.length; i++) {
            if (ide.toElement.id === this.portfolioJSON[i].id) {
              
                this.dialogInf = this.portfolioJSON[i];
                this.innerProducts = this.portfolioJSON[i].products;
              

              console.log("hihehheh");
            }
          } 
        } else {
          console.log("error");
        }
      }
    }
  }
};
</script>
<style scoped>
#arrowdown {
  text-align: right;
}
.centerDiv
    {
      width: 60%;
      height:200px;
      margin: 0 auto;
      background-color:#FFA500 ;
    }
    .div1
    {
      width: 50%;
      height:200px;
      background-color:#A52A2A ;
      float:left;
    }
    .div2
    {
      width: 50%;
      height:200px;
      background-color:#FFA500 ;
      float:left;
    }
    .v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: .8;
  position: absolute;
  width: 100%;
}
</style>
